import { mapActions, mapState } from 'vuex'
import { GET_DATA_OBJECT_LIST, GET_DATA_SERVICE_LIST } from '@store/types'

export default {
    data() {
        return {
            businessEnvId: '', // 在其他混入的 js 中会更新
        }
    },

    computed: {
        ...mapState({
            appInfo: state => state.modeling.app,
        }),
        isCurrentBusinessEnvId() {
            const { businessEnvId: currentBusinessEnvId } = this.appInfo
            return currentBusinessEnvId && (currentBusinessEnvId === this.businessEnvId)
        },
    },
  
    methods: {
        ...mapActions({
            getDataServiceList: `emulator/${GET_DATA_SERVICE_LIST}`,
            getDataObjectList: `emulator/${GET_DATA_OBJECT_LIST}`,
        }),

        // 更新仿真器中引用的业务对象
        updateDesignerDataObjectList() {
            if (this.isCurrentBusinessEnvId) {
                this.getDataObjectList()
            }
        },

        // 更新仿真器中引用的对象服务
        updateDesignerDataServiceList() {
            if (this.isCurrentBusinessEnvId) {
                this.getDataServiceList()
            }
        },
    },
}
